export type DevToolsConfig = {
    enabled: boolean;
  
    /** Hotkey for pause toggle (e.g. "KeyP", "Space", "Escape") */
    pauseToggleKeyCode: string;

    /** Hotkey to advance ONE frame while paused (e.g. "KeyN", "Period"). */
    stepFrameKeyCode: string;
  
    /** What the badge shows */
    badgeText: string;
  };
  
  export const DEFAULT_DEVTOOLS_CONFIG: DevToolsConfig = {
    enabled: false,
    pauseToggleKeyCode: "KeyP",
    stepFrameKeyCode: "KeyN",
    badgeText: "DEV",
  };